export default __webpack_public_path__ + "static/media/pay.cffab7be.png";